module.exports = __webpack_public_path__ + "img/toggleEnabled.47a58867.svg";